export default __webpack_public_path__ + "static/apartment-therapy-ecf0e53b1b84879f70b181de234de636.svg";